<template>
  <router-link class="Product-Item" tag='li' :to="{ name: 'Product', params: { module_id: moduleId, product_id: product.product_id } }" >
    <div class="Product">
    <div class="Product-Image">
      <img class="" :src="picture" :alt="product.name">

      <div class="Product-Tag">
        <span class="Product-Name test-product_title">{{ product.name }}</span>
        <span class="Product-Price test-product_item" :class="{'Product-Price--Disabled': product.is_disabled}">
          {{ price | formatCurrency(currency) }}
        </span>
      </div>
    </div>
    </div>
  </router-link>
</template>

<script>
  export default {
    props: {
      product: {
        type: Object,
        required: true
      },
      currency: {
        type: String,
        required: false,
      },
      moduleId: {},
      apiUrl: {}
    },

    computed: {
      price () {
        return this.product.is_disabled ? this.$t('list.sale_closed') : this.getPrice();
      },
      picture () {
        let images = this.product.image || {};

        if (images.hasOwnProperty('default')) {
          let index = images.default ? images.default : 0;
          return this.apiUrl + 'data/' + images.listOfImages[index];
        }

        if (Array.isArray(images) && images.length) {
          return this.apiUrl + 'data/' + images[0];
        }

        return '/static/default_product.jpg';
      }
    },

    methods: {
      getPrice () {
        let price = this.product.price;
        if (this.product.price_list && this.product.price_list_data && this.product.price_list_data.values.length) {
          let values = this.product.price_list_data.values.sort((a, b) => {
            return a.value - b.value;
          });

          price = values[0].value + ' - ' + values[values.length - 1].value;
        }

        return price;
      }
    }
  };
</script>

<style scoped>
    .Product-Item {
      max-width: 100%;
    }

    .Product {
      padding: 7px;
      /* display: flex; */
    }

    .Product-Image {
      /* border: 1.2px solid #eaeaea; */
      display: flex;
      flex-direction: column;
    }

    .Product-Image img {
      display: block;
      max-width: 100%
    }

    .Product-Tag {
      padding: 5px;
    }

    .Product-Name {
      display: block;
      font-family: 'Roboto Condensed';
      font-size: 1.2em;
      color: #222;
      line-height: 1.2em;
      font-weight: 600;
      text-transform: uppercase;

      /* this couse the scroll in iphone */
      /* Shorten text */
      /* white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis; */
    }

    .Product-Price {
      display: block;
      font-family: 'Roboto';
      font-size: 1.30em;
      color: #04BE5B;
      font-weight: 500;
    }

    .Product-Price--Disabled {
      background-color: red;
      color:#ffffff;
      font-weight: 400;
      font-family: 'Roboto';
      font-size: 1em;
      text-transform: uppercase;
      padding: 5px;
    }

    @media screen and (min-width: 576px) {
      .Product-Item {
        max-width: 50%;
      }
    }

    @media screen and (min-width: 768px) {
      .Product-Item {
        max-width: 33.33%;
      }
    }

    @media screen and (min-width: 1024px) {
      .Product-Item {
        max-width: 25%;
      }
    }
</style>



// WEBPACK FOOTER //
// product.vue?11a23d63